"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactImmutableProptypes = require("react-immutable-proptypes");

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIColumnSpreads = _interopRequireDefault(require("UIComponents/column/UIColumnSpreads"));

var _UIColumnWrapper = _interopRequireDefault(require("UIComponents/column/UIColumnWrapper"));

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _Interaction = _interopRequireDefault(require("./wrappers/Interaction"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIOverlay = _interopRequireDefault(require("UIComponents/overlay/UIOverlay"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogButton"));

var _ErrorBoundary = _interopRequireDefault(require("customer-data-objects-ui-components/ErrorBoundary"));

var _CommunicatorError = _interopRequireDefault(require("./CommunicatorError"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var propTypes = {
  LocalSettings: _react.PropTypes.object.isRequired,
  applicabilityConfig: _react.PropTypes.func.isRequired,
  connectRte: _react.PropTypes.func.isRequired,
  gates: (0, _reactImmutableProptypes.setOf)(_react.PropTypes.string),
  handleCloseCommunicator: _react.PropTypes.func,
  isFullScreenEnabled: _react.PropTypes.bool,
  interactionPassThruProps: (0, _reactImmutableProptypes.mapOf)(_react.PropTypes.object, _react.PropTypes.string).isRequired,
  interactions: _react.PropTypes.shape({
    activate: _react.PropTypes.func.isRequired,
    getAllDescriptors: _react.PropTypes.func.isRequired,
    getDefault: _react.PropTypes.func.isRequired,
    getDescriptor: _react.PropTypes.func.isRequired
  }).isRequired,
  objectType: _ProfileObjectTypesType.default.isRequired,
  onInteractionEvent: _react.PropTypes.func.isRequired,
  onInteractionTypeChanged: _react.PropTypes.func.isRequired,
  ownerId: _react.PropTypes.number.isRequired,
  teamId: _react.PropTypes.number,
  paddingClassName: _react.PropTypes.string.isRequired,
  selected: _react.PropTypes.string.isRequired,
  showHeader: _react.PropTypes.bool,
  subject: _SubjectType.default.isRequired,
  className: _react.PropTypes.string,
  isMinimized: _react.PropTypes.bool,
  isFullScreen: _react.PropTypes.bool,
  handleToggleMinimize: _react.PropTypes.func,
  handleToggleFullScreen: _react.PropTypes.func,
  title: _react.PropTypes.node,
  onPasteContent: _react.PropTypes.func,
  handleUsageLogging: _react.PropTypes.func.isRequired,
  gdprDisabled: _react.PropTypes.bool,
  handleResizeIframe: _react.PropTypes.func,
  handleNavigationTriggered: _react.PropTypes.func
};
var defaultProps = {
  interactionPassThruProps: (0, _immutable.Map)(),
  paddingClassName: '',
  handleToggleMinimize: function handleToggleMinimize() {
    return null;
  },
  handleToggleFullScreen: function handleToggleFullScreen() {
    return null;
  },
  isFullScreen: false,
  isMinimized: false,
  isFullScreenEnabled: false,
  showHeader: true,
  gdprDisabled: false,
  onPasteContent: _emptyFunction.default,
  handleResizeIframe: _emptyFunction.default,
  handleNavigationTriggered: _emptyFunction.default
};
var BASE_STRING = 'customerDataCommunicator.Communicator.floatingCommunicator';

var FloatingCommunicatorInteraction =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FloatingCommunicatorInteraction, _PureComponent);

  function FloatingCommunicatorInteraction(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FloatingCommunicatorInteraction);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FloatingCommunicatorInteraction).call(this, props));
    _this.partial = (0, _ComponentMethods.makePartial)();
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      type: ''
    };
    return _this;
  }

  (0, _createClass2.default)(FloatingCommunicatorInteraction, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.interactionComponentCache = {};
      this.getInteractionComponent(this.props.selected);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (this.props.selected !== newProps.selected) {
        this.getInteractionComponent(newProps.selected);
      }
    }
  }, {
    key: "getSelectedDescriptor",
    value: function getSelectedDescriptor() {
      return this.state.type ? this.props.interactions.getDescriptor(this.state.type) : this.props.interactions.getDescriptor(this.props.selected);
    }
  }, {
    key: "getWrapperClasses",
    value: function getWrapperClasses() {
      var _this$props = this.props,
          selected = _this$props.selected,
          isMinimized = _this$props.isMinimized,
          isFullScreen = _this$props.isFullScreen,
          className = _this$props.className;
      return (0, _classnames.default)('communicator', 'communicator--floating', "floating-panel-is-" + selected, className, {
        'communicator--minimized': isMinimized,
        'communicator--fullscreen': isFullScreen
      });
    }
  }, {
    key: "getInteractionComponent",
    value: function getInteractionComponent(type) {
      if (!this.interactionComponentCache[type]) {
        var interactionDescriptorRecord = this.props.interactions.getDescriptor(type);
        this.interactionComponentCache[type] = (0, _Interaction.default)(interactionDescriptorRecord);
      }

      return this.interactionComponentCache[type];
    }
  }, {
    key: "handleClose",
    value: function handleClose(evt) {
      var handleCloseCommunicator = this.props.handleCloseCommunicator;
      evt.stopPropagation();
      handleCloseCommunicator();
    }
  }, {
    key: "handleToggleFullScreen",
    value: function handleToggleFullScreen() {
      var interactionType = this.getSelectedDescriptor().type.toUpperCase();
      this.props.handleToggleFullScreen(interactionType);
    }
  }, {
    key: "handleLoggedActivityTypeChange",
    value: function handleLoggedActivityTypeChange(type) {
      this.setState({
        type: type
      });
    }
  }, {
    key: "renderInteractionComponent",
    value: function renderInteractionComponent() {
      var _this$props2 = this.props,
          interactionPassThruProps = _this$props2.interactionPassThruProps,
          subject = _this$props2.subject,
          connectRte = _this$props2.connectRte,
          gates = _this$props2.gates,
          handleCloseCommunicator = _this$props2.handleCloseCommunicator,
          LocalSettings = _this$props2.LocalSettings,
          objectType = _this$props2.objectType,
          onInteractionEvent = _this$props2.onInteractionEvent,
          ownerId = _this$props2.ownerId,
          teamId = _this$props2.teamId,
          paddingClassName = _this$props2.paddingClassName,
          handleUsageLogging = _this$props2.handleUsageLogging,
          onPasteContent = _this$props2.onPasteContent,
          gdprDisabled = _this$props2.gdprDisabled,
          handleResizeIframe = _this$props2.handleResizeIframe,
          handleNavigationTriggered = _this$props2.handleNavigationTriggered;
      var descriptor = this.getSelectedDescriptor();
      var engagementType = descriptor.engagementType,
          passthruRtePlugins = descriptor.passthruRtePlugins;
      var InteractionComponent = this.getInteractionComponent(descriptor.type);
      var passtThruProps = interactionPassThruProps.get(descriptor.type);
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('floating-communicator-body', {
          'floating-communicator-body--fullscreen': this.props.isFullScreen
        }),
        "data-selenium-test": "floating-communicator-body"
      }, _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, passtThruProps, {
        connectRte: connectRte,
        descriptor: descriptor,
        engagementType: engagementType,
        gates: gates,
        handleCloseCommunicator: handleCloseCommunicator,
        useMultipleAssociationsSelect: true,
        isFullScreen: this.props.isFullScreen,
        LocalSettings: LocalSettings,
        objectType: objectType,
        onInteractionEvent: onInteractionEvent,
        onLoggedActivityTypeChange: this.handleLoggedActivityTypeChange,
        ownerId: ownerId,
        teamId: teamId,
        paddingClassName: paddingClassName,
        passthruRtePlugins: passthruRtePlugins,
        subject: subject,
        subjectId: "" + (0, _ObjectRecordAccessors.getId)(subject),
        handleUsageLogging: handleUsageLogging,
        onPasteContent: onPasteContent,
        gdprDisabled: gdprDisabled,
        handleResizeIframe: handleResizeIframe,
        handleNavigationTriggered: handleNavigationTriggered
      })));
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var isMinimized = this.props.isMinimized;

      var _this$getSelectedDesc = this.getSelectedDescriptor(),
          engagementType = _this$getSelectedDesc.engagementType;

      var message = engagementType ? 'customerDataCommunicator.componentErrorAlert.communicatorErrorOption' : 'customerDataCommunicator.componentErrorAlert.communicatorErrorGeneric';
      return _react.default.createElement("div", {
        className: "communicator-body",
        style: isMinimized ? {
          height: 0
        } : {}
      }, _react.default.createElement(_ErrorBoundary.default, {
        ErrorComponent: _CommunicatorError.default,
        errorProps: {
          detail: _I18n.default.text(message, {
            type: engagementType ? engagementType.toLocaleLowerCase() : null
          })
        }
      }, this.renderInteractionComponent()));
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      return _react.default.createElement(_UIDialogButton.default, {
        "data-selenium-test": "close-floating-communicator",
        "aria-label": "Close dialog",
        className: "m-x-2",
        onClick: this.handleClose,
        iconName: "remove"
      });
    }
  }, {
    key: "renderFullScreenToggle",
    value: function renderFullScreenToggle() {
      var _this$props3 = this.props,
          isFullScreenEnabled = _this$props3.isFullScreenEnabled,
          isFullScreen = _this$props3.isFullScreen;

      if (!isFullScreenEnabled) {
        return null;
      }

      var type = isFullScreen ? 'close' : 'open';

      var title = _react.default.createElement(_FormattedMessage.default, {
        message: BASE_STRING + ".fullScreenTooltip." + type
      });

      return _react.default.createElement(_UITooltip.default, {
        title: title,
        placement: "bottom"
      }, _react.default.createElement(_UIDialogButton.default, {
        "aria-label": "Expand dialog",
        className: "m-x-2",
        "data-selenium-test": "full-screen-communicator-button",
        onClick: this.handleToggleFullScreen,
        iconName: isFullScreen ? 'exitFullScreen' : 'enlarge'
      }));
    }
  }, {
    key: "renderMinimizeToggle",
    value: function renderMinimizeToggle() {
      var handleToggleMinimize = this.props.handleToggleMinimize;
      return _react.default.createElement(_UIDialogButton.default, {
        "aria-label": "Minimize dialog",
        className: "m-x-2",
        onClick: handleToggleMinimize,
        iconName: "minus",
        "data-selenium-test": "floating-communicator-minimize-button"
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      return _react.default.createElement(_UIColumn.default, {
        "data-floating-communicator-actions": true
      }, this.renderMinimizeToggle(), this.renderFullScreenToggle(), this.renderCloseButton());
    }
  }, {
    key: "renderDefaultTitle",
    value: function renderDefaultTitle() {
      var selected = this.props.selected;
      return _react.default.createElement(_FormattedMessage.default, {
        message: BASE_STRING + "." + (this.state.type || selected)
      });
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props4 = this.props,
          handleToggleMinimize = _this$props4.handleToggleMinimize,
          _this$props4$title = _this$props4.title,
          title = _this$props4$title === void 0 ? this.renderDefaultTitle() : _this$props4$title;
      return _react.default.createElement(_UIColumnSpreads.default, null, _react.default.createElement("div", {
        onClick: handleToggleMinimize,
        className: "pointer"
      }, _react.default.createElement("h5", {
        className: "m-all-0 p-all-0"
      }, title)));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      if (!this.props.showHeader) {
        return null;
      }

      return _react.default.createElement(_UIDialogHeader.default, {
        className: (0, _classnames.default)('communicator-header', 'p-x-5', {
          'communicator-header--fullscreen': this.props.isFullScreen
        })
      }, _react.default.createElement(_UIColumnWrapper.default, {
        align: "center"
      }, this.renderTitle(), this.renderActions()));
    }
  }, {
    key: "renderCommunicator",
    value: function renderCommunicator() {
      return _react.default.createElement(_UICardWrapper.default, {
        className: this.getWrapperClasses(),
        "data-selenium-test": "profile-interactions",
        "data-onboarding": "profile-interactions"
      }, this.renderHeader(), this.renderBody());
    }
  }, {
    key: "renderFullScreenCommunicator",
    value: function renderFullScreenCommunicator() {
      return _react.default.createElement(_UIOverlay.default, {
        "data-selenium-test": "full-screen-communicator",
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
        width: 1500
      }, this.renderCommunicator());
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.isFullScreen ? this.renderFullScreenCommunicator() : this.renderCommunicator();
    }
  }]);
  return FloatingCommunicatorInteraction;
}(_PureComponent2.default);

FloatingCommunicatorInteraction.propTypes = propTypes;
FloatingCommunicatorInteraction.defaultProps = defaultProps;
var _default = FloatingCommunicatorInteraction;
exports.default = _default;
module.exports = exports.default;